import React from 'react';
import { Container, Typography } from '@mui/material';
import SentimentVeryDissatisfiedIcon from '@mui/icons-material/SentimentVeryDissatisfied';
import { AppMain } from '../layout/appMain';

const styles = {
  wrongPageContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
  },
  iconSad: {
    m: 10,
    fontSize: '10rem',
  },
};

export function Page404(): JSX.Element {
  return (
    <AppMain>
      <Container sx={styles.wrongPageContainer}>
        <SentimentVeryDissatisfiedIcon sx={styles.iconSad} />
        <Typography variant="h1">404</Typography>
        <Typography variant="h5">Not Found</Typography>
      </Container>
    </AppMain>
  );
}
